import React, { useState } from 'react';
import { Grid, TextField, Card, CardContent, Typography, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Stack from '@mui/material/Stack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function AddExperianceDetail({ formData, handleFormDataChange,setValue }) {
    const [fileNames, setFileNames] = useState({});

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleFileChange = (field) => async (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileNames(prev => ({
                ...prev,
                [field]: file.name
            }));

            const base64 = await convertToBase64(file);
            handleFormDataChange('experience', {
                ...formData.experience,
                [field]: base64
            });
        }
    };

    const handleExperienceChange = (field) => (event) => {
        handleFormDataChange('experience', {
            ...formData.experience,
            [field]: event.target.value
        });
    };

    const handleReferenceChange = (field) => (event) => {
        handleFormDataChange('experience', {
            ...formData.experience,
            prof_ref: {
                ...formData.experience?.prof_ref,
                [field]: event.target.value
            }
        });
    };
    const handleNext = () => {
        setValue('Bank Details');
    };


    return (
        <Card sx={{ margin: 2 }}>
            <CardContent>
                <Typography color="#1976d2" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                    <strong style={{fontWeight:600}}>Experience Details</strong>
                </Typography>

                {/* Previous Employment Details */}
                <Card sx={{ marginBottom: 3, padding: 2 }}>
                    <Typography variant="h6" color="#1976d2" gutterBottom sx={{marginBottom:{xs:"1em"}}}>
                        Previous Employment
                    </Typography>
                    <Grid container spacing={5.5}>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Employer Name"
                                value={formData.experience?.employer_name || ''}
                                onChange={handleExperienceChange('employer_name')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Designation"
                                value={formData.experience?.designation || ''}
                                onChange={handleExperienceChange('designation')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <input
                                type="file"
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                onChange={handleFileChange('exp_letter')}
                                style={{ display: 'none' }}
                                id="exp-letter-upload"
                            />
                            <label htmlFor="exp-letter-upload">
                                <Button
                                    variant="outlined"
                                    component="span"
                                    startIcon={<CloudUploadIcon />}
                                    size='medium'
                                    sx={{
                                        width: "100%",
                                        padding: '7px 0px',
                                    }}
                                >
                                    {formData.experience.exp_letter||fileNames.exp_letter || 'Upload Experience Letter'}
                                </Button>
                            </label>
                            {formData.experience?.exp_letter && (
                                <Typography variant="caption" display="block" sx={{ mt: 1, color: 'green' }}>
                                    File saved successfully
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Card>

                {/* Professional Reference */}
                <Card sx={{ padding: 2 }}>
                    <Typography variant="h6" color="#1976d2" gutterBottom sx={{marginBottom:{xs:"1em"}}}>
                        Professional Reference
                    </Typography>
                    <Grid container spacing={5.5}>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="Name"
                                value={formData.experience?.prof_ref?.name || ''}
                                onChange={handleReferenceChange('name')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="Designation"
                                value={formData.experience?.prof_ref?.designation || ''}
                                onChange={handleReferenceChange('designation')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="Organization"
                                value={formData.experience?.prof_ref?.organization || ''}
                                onChange={handleReferenceChange('organization')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="Mobile Number"
                                value={formData.experience?.prof_ref?.mobile_num || ''}
                                onChange={handleReferenceChange('mobile_num')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ height: "80px", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <Stack direction="row" spacing={2}>
                                <Button
                                    variant="contained"
                                    endIcon={<ArrowForwardIcon />}
                                    onClick={handleNext}
                                >
                                    Next
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </Card>
            </CardContent>
        </Card>
    );
}

export default AddExperianceDetail;